import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";


import { getCompanies } from "../../../../../MyApi/hr/companies";

import icons from "../../../../../Data/icons";
import LoadingSpinner from "../../../../UI/spinner";

import classes from "./addShift.module.css";
import { useEffect } from "react";

const EditShift = ({
  shiftName,
  active,
  setActive,
  setCompanyId,
  setshiftName,
  flexible,
  setFlexible,
  breakTime,
  setBreakTime,
  setWeekData,
  weeksData,
  companyId
  
}) => {
  const { data, isLoading } = useQuery("getcompanies", getCompanies);
  const { t } = useTranslation();
  const companies = data?.data || []; 
  
useEffect(()=>{

  if (flexible === 0) {  
   
    setWeekData((prevWeekData) => 
      prevWeekData.map((item) => (
       {
        ...item,
        
        flexible_hours:null  

      }))
    );

  }
},[flexible])

useEffect(()=>{

  if (breakTime === 0) {  

    setWeekData((prevWeekData) => 
      prevWeekData.map((item) => (
       {
        ...item,
        start_break: null,
        end_break: null,

      }))
    );

  }
},[breakTime])


  const WorkShift = icons.workShifts;
  const Company = icons.company;

  const handleNameChange = (e) => {
    setshiftName(e.target.value);
  };

  const handleCompanyIdChange = (e) => {
    setCompanyId(e.target.options[e.target.selectedIndex].id);
  };

  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
   setActive(isChecked ? 1 :0)
  };
  const handleFlexibleChange = (e) => {
    const isChecked = e.target.checked;
   setFlexible(isChecked ? 1 :0)
  };

  const handleBreakChange = (e) => {
    const isChecked = e.target.checked;
    setBreakTime(isChecked ?1 :0) 
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }
  const handleInputChange =(day ,field ,value)=>{
const updatedWeekData =weeksData.map((item)=>(
  item.day === day ? {...item , [field] :value } :item
))
setWeekData(updatedWeekData)
  }
 

  const handleCheckboxChange = (day, field, checked) => {
    const updatedWeekData = weeksData.map((item) =>
      item.day === day ? { ...item, [field]: checked ? 1 : 0 ,...(field === "day_off" &&
        checked && {
          start_time: null,
          end_time: null,
          start_checkin: null,
          end_checkin: null,
          start_checkout: null,
          end_checkout: null,
          start_break: null,
          end_break: null,
          flexible_hours: null,
        }),
        ...(field === "break" &&
          !checked && {
            start_break: null,
            end_break: null,
          }),
          ...(field === "flexible" &&
            checked && {
              start_time: null,
              end_time: null,
              start_checkin: null,
              end_checkin: null,
              start_checkout: null,
              end_checkout: null,
            }),
      
      } : item
    );
    setWeekData(updatedWeekData);
  };

  return (
    <div className={classes.formCard}>
      <h5 className={classes.headTitle}>معلومات نوبة العمل</h5>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم نوبة العمل</label>
          <div className={classes.iconInput}>
            <WorkShift />
          </div>
          <input
            type="text"
            placeholder=" ادخل اسم   نوبة العمل"
            onChange={handleNameChange}
            value={shiftName}
            className={classes.inputCustom}
          />
        </div>

        <div className={classes.formCol}>
          <label
            htmlFor="currency"
            className={active ? `${classes.active}` : `${classes.disActive}`}>
            {" "}
            {active === 1 ? " نشط" : "غير نشط"}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleActiveChange}
              checked={active}
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div className={classes.formCol}>
          <label htmlFor="company">اختار الشركة</label>
          <div className={classes.iconInput}>
            <Company />
          </div>
          <select
            onChange={handleCompanyIdChange}
            className={classes.inputCustom}>
            <option value="">اختار الشركة</option>
            {companies.map((company) => (
              <option key={company.id} selected={company.id===companyId} id={company.id} value={company.name}>
                {company.name}
              </option>
            ))}
          </select>
        </div>
        <div className={classes.formCol}>
          <label
            htmlFor="flexible"
            className={flexible ? `${classes.active}` : `${classes.disActive}`}>
            {" "}
            {flexible === 1 ? " مرن" : "غير مرن"}{" "}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleFlexibleChange}
              checked={flexible}
              className={classes.inputCustom}
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div className={classes.formCol}>
          <label
            htmlFor="break"
            className={
              breakTime ? `${classes.active}` : `${classes.disActive}`
            }>
            {" "}
            {breakTime === 1 ? "استراحة" : "بلا استراحة"}{" "}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleBreakChange}
              checked={breakTime}
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <table>
        <thead>
        <th>{t("days")}</th>
          <th>{t("start time")}</th>
          <th>{t("end time")}</th>
          <th>{t("start checkin")}</th>
          <th>{t("end checkin")}</th>
          <th>{t("start checkout")}</th>
          <th>{t("end checkout")}</th>
           {breakTime === 1&&<><th>{t("start break")}</th>
          <th>{t("end break")}</th></>}
         {flexible ===1&& <> <th>{t("flexible hours")} </th>  <th>{t("flexible")}</th>   </>}
      
         {breakTime ===1 && <th>{t("break")}</th>}
          <th>{t("day off")}</th>
        </thead>
        <tbody>
        {weeksData.map((dayData) => {
         
          return   <tr key={dayData.day}>
            <td>{dayData.day}</td>
            <td>
              <input
                type="time"
                value={dayData.start_time}
                className={classes.tabelInput}
                disabled={dayData.flexible === 1 || dayData.day_off === 1}
                onChange={(e) => handleInputChange(dayData.day, "start_time", e.target.value)}
              />
            </td>
            <td>
              <input
                type="time"
                value={dayData.end_time}
                className={classes.tabelInput}
                disabled={dayData.flexible === 1|| dayData.day_off === 1}
                onChange={(e) => handleInputChange(dayData.day, "end_time", e.target.value)}
              />
            </td>
            <td>
              <input
                type="time"
                value={dayData.start_checkin}
                className={classes.tabelInput}
                disabled={dayData.flexible === 1|| dayData.day_off === 1}
                onChange={(e) => handleInputChange(dayData.day, "start_checkin", e.target.value)}
              />
            </td>
            <td>
              <input
                type="time"
                value={dayData.end_checkin}
                className={classes.tabelInput}
                disabled={dayData.flexible === 1|| dayData.day_off === 1}
                onChange={(e) => handleInputChange(dayData.day, "end_checkin", e.target.value)}
              />
            </td>
            <td>
              <input
                type="time"
                value={dayData.start_checkout}
                className={classes.tabelInput}
                disabled={dayData.flexible === 1|| dayData.day_off === 1}
                onChange={(e) => handleInputChange(dayData.day, "start_checkout", e.target.value)}
              />
            </td>
            <td>
              <input
                type="time"
                value={dayData.end_checkout}
                className={classes.tabelInput}
                disabled={dayData.flexible === 1|| dayData.day_off === 1}
                onChange={(e) => handleInputChange(dayData.day, "end_checkout", e.target.value)}
              />
            </td>
         
          
           { breakTime ===1 &&<>  <td>
              <input
                type="time"
                disabled={dayData.break ===0 || dayData.day_off === 1}
                value={dayData.start_break}
                className={classes.tabelInput}
                onChange={(e) => handleInputChange(dayData.day, "start_break", e.target.value)}
              />
            </td>
            <td>
              <input
                type="time"
                value={dayData.end_break}
                className={classes.tabelInput}
                disabled={dayData.break ===0|| dayData.day_off === 1}
                onChange={(e) => handleInputChange(dayData.day, "end_break", e.target.value)}
              />
            </td></>
           }
             { flexible ===1 &&
            <td>
              <input
                type="time"
                value={dayData.flexible_hours}
                className={classes.tabelInput}
                disabled={ dayData.day_off === 1 || dayData.flexible ===0}
                onChange={(e) => handleInputChange(dayData.day, "flexible_hours", e.target.value)}
              />
            </td>}
          { flexible ===1 && <td>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={dayData.flexible ===1 }
                  className={classes.tabelInput}
                  onChange={(e) => handleCheckboxChange(dayData.day, "flexible", e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
            </td>}
        { breakTime ===1 &&   <td>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={dayData.break ===1}
                  onChange={(e) => handleCheckboxChange(dayData.day, "break", e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
            </td>}
            <td>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={dayData.day_off ===1}
                  onChange={(e) => handleCheckboxChange(dayData.day, "day_off" , e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
            </td>
          </tr>
        }
       
        )}
      </tbody>
      </table>
    </div>
  );
};

export default EditShift;
